export default __webpack_public_path__ + "static/media/gallery-image-8-full.df15eb9e.jpg";